/**
 * Created by danielgw on 5/25/17.
 *
 * This service use the Batchelor recipe in order to send one request to 3 different API.
 * Getting the agentIds from the first api and sends it as param to the others.
 */

define(function (require) {

    lpTag.WebAgent = lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpBaseService = require('web-agent-services/BaseService');


    var APPLICATION_TYPE = 'lpMessagingAgentsListService';
    var TIMEOUT = 10000;
    var TIMEFRAME = '720';
    var BASE = lpBaseService;
    var batchelorResources;

    var lpMessagingAgentsListService = function () {
        BASE.call(this, {
            serviceName: 'Batchelor'
        });
        this._initializeApiResource();
    };

    lpUtils.extend(lpMessagingAgentsListService, BASE);

    lpMessagingAgentsListService.prototype = new lpBaseService();

    lpMessagingAgentsListService.prototype.applicationType = APPLICATION_TYPE;

    lpMessagingAgentsListService.prototype._initializeApiResource = function () {
        // validate configuration and resource lookup:
        if (!this.apiResourceService) {
            return this.logger.error('cannot create end points for the service, no service end point.');
        }

        // this should be corresponding with the apiResources.json file.
        this.apiEndPoints = {
            BatchelorRecipe: this.createAPIEndPointService('BatchelorRecipe')
        };
        batchelorResources = agentLEManager.getLEUrlResolverApiResourcesService('Batchelor');

    };

    lpMessagingAgentsListService.prototype._createBatchData = function(serviceName, resourceName, method, urlQuery, bodyData, batchName ) {
        var fullResourceUrl;
        var serviceResources = agentLEManager.getLEUrlResolverApiResourcesService(serviceName);
        if (serviceResources && serviceResources[resourceName] && serviceResources[resourceName].url) {
            fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(serviceResources[resourceName].url);
        }

        var batchData = {'name': batchName || resourceName,
            'method':method,
            'url':fullResourceUrl + urlQuery,
            'headers':{'accept':'application/json'},
            'body': bodyData ? bodyData : '',
            'timeout':TIMEOUT
        };
        return batchData;
    };

    lpMessagingAgentsListService.prototype._createSearchAgentsBatchData = function(reqObj) {
        var urlQuery = '?';
        if (reqObj.query) {
            for (var key in reqObj.query){
                urlQuery += key+'='+reqObj.query[key]+'&';
            }
        }
        urlQuery += 'NC=true'; //TODO: ask about it
        var serviceName = agentLEManager.getCSDSRecord('msgHist') ? "MessagingEngagementsHistory" : "MessagingEngagementsHistoryOnSharedServers";
        return this._createBatchData(serviceName, 'SearchAgents', 'POST', urlQuery, reqObj.data, 'SearchAgents');
    };

    lpMessagingAgentsListService.prototype._createAgentActivityBatchData = function() {
        var urlQuery = '';
        var bodyData = {
            "timeframe": TIMEFRAME,
            "v":"1",
            "agentIds": "{{{SearchAgents.body.agentStatusRecords[*].agentId | join(', ', @) }}}",
            "isUseCache": "false"
        };
        return this._createBatchData('DataAgent', 'AgentActivity', 'POST', urlQuery,bodyData);
    };

    lpMessagingAgentsListService.prototype._createMessagingConversationBatchData = function() {
        var urlQuery = '';
        var bodyData = {
            "timeframe": TIMEFRAME,
            "v":"1",
            "agentIds": "{{{SearchAgents.body.agentStatusRecords[*].agentId | join(', ', @) }}}"
        };

        return this._createBatchData('DataAgent', 'MessagingConversation_post', 'POST', urlQuery, bodyData, 'MessagingConversation');
    };

    lpMessagingAgentsListService.prototype.searchAgents = function(reqObj) {
        reqObj.callingFunction = 'searchAgents';
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.additionalUrl = this.apiEndPoints.BatchelorRecipe.additionalUrl;

        var searchAgentsBatchData = this._createSearchAgentsBatchData(reqObj);
        var agentActivityBatchData = this._createAgentActivityBatchData();
        var messagingConversationBatchData = this._createMessagingConversationBatchData();

        reqObj.data =
            {
                "type": "RECIPE",
                "data": {},
                "recipeName": "myRecipe",
                "recipe": [
                    [
                        {
                            "name": searchAgentsBatchData.name,
                            "headers":searchAgentsBatchData.headers,
                            "method": searchAgentsBatchData.method,
                            "body": searchAgentsBatchData.body,
                            "url": searchAgentsBatchData.url,
                            "timeout": searchAgentsBatchData.timeout
                        }
                    ],
                    [
                        {
                            "name": agentActivityBatchData.name,
                            "headers":agentActivityBatchData.headers,
                            "method": agentActivityBatchData.method,
                            "body": agentActivityBatchData.body,
                            "url": agentActivityBatchData.url,
                            "timeout": agentActivityBatchData.timeout
                        }
                    ],
                    [
                        {
                            "name": messagingConversationBatchData.name,
                            "headers":messagingConversationBatchData.headers,
                            "method": messagingConversationBatchData.method,
                            "body": messagingConversationBatchData.body,
                            "url": messagingConversationBatchData.url,
                            "timeout": messagingConversationBatchData.timeout
                        }
                    ],
                    [
                        {
                            "name": "Result",
                            "data": {
                                "SearchAgents": "{{{"+searchAgentsBatchData.name+"}}}",
                                "AgentActivity": "{{{"+agentActivityBatchData.name+"}}}",
                                "MessagingConversation": "{{{"+messagingConversationBatchData.name+"}}}"
                            }
                        }
                    ]
                ]
            };

        reqObj.query = '';

        if (reqObj.pollingCallback) {
            this.apiEndPoints.BatchelorRecipe.startPolling(reqObj);
            // this is important, it's let the invoker to stop the polling by demand.
            return this.apiEndPoints.BatchelorRecipe.stopPolling.bind(this);
        } else {
            this.apiEndPoints.BatchelorRecipe.stopPolling();
            this.apiEndPoints.BatchelorRecipe.sendRequest(reqObj);
        }
    };

    return lpMessagingAgentsListService;

});
